import { render, staticRenderFns } from "./AccountDeletion.vue?vue&type=template&id=6f3789cf&scoped=true"
import script from "./AccountDeletion.vue?vue&type=script&lang=js"
export * from "./AccountDeletion.vue?vue&type=script&lang=js"
import style0 from "./AccountDeletion.vue?vue&type=style&index=0&id=6f3789cf&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f3789cf",
  null
  
)

export default component.exports